@if (viewContent) {
  <router-outlet></router-outlet>
}
